// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

import type {Theme} from '@material-ui/core';

type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 500,
    padding: theme.spacing(4, 1, 4, 1),
  },
  title: {
    color: colors.grey1000,
    fontSize: 22,
    fontWeight: 600,
  },
  infoText: {
    color: colors.grey800,
    fontSize: 16,
  },
  infoTextWrap: {
    margin: theme.spacing(2, 0),
  },
}));

export default function RedeemedSubscriptionModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          ¡Genial! Tu siguiente <br /> suscripción se renovará con <br /> tus
          puntos.
        </Typography>

        <div className={classes.infoTextWrap}>
          <Typography className={classes.infoText} align="center">
            Una vez finalizado tu plan actual se renovará tu nuevo plan con tus
            puntos{' '}
            <span role="img" aria-label="emoji">
              🎊
            </span>
          </Typography>
        </div>
        <CustomButton fullWidth variant="outlined" to="/home">
          Ir al panel
        </CustomButton>
      </div>
    </CustomModal>
  );
}

RedeemedSubscriptionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
